<template>
    <div class="MeetingActivitiesWarp">
        <div>
            <NavMenu/>
        </div>

        <div class="primaryTitle">
            <span class="left-line"></span>
            <span class="title">会议活动</span>
            <span class="right-line"></span>
        </div>

        <div class="contentDataBox1">
            <div class="rightMore" @click="gosecondPageFn1">
                <span class="morebox">
                    更多
                    <i class="el-icon-caret-right"></i>
                </span>
            </div>
            <div class="meetbox">
                <div class="dataInfoItem" v-for="(item,index) in confereeData" :key="index">
                    <div class="meetName overflowone" @click="jumpdetailFn">
                        {{item.confereeName}}
                    </div>
                    <div class="line"></div>
                    <div class="textbox">
                        <div>会议活动编码：{{item.confereeCode}}</div>
                        <div>会议活动起止时间：{{item.confereeStartTime}} 至{{item.confereeEndTime}}</div>
                        <div>会议活动地点：{{item.confereeSite}}</div>
                        <div>发布机构：{{item.publishOrganization}}</div>
                    </div>
                    <div class="meetdetailBtn" @click="goconfereeDetailFn(item)">
                        详情
                    </div>

                </div>
            </div>
        </div>

        <div class="primaryTitle">
            <span class="left-line"></span>
            <span class="title">品牌活动</span>
            <span class="right-line"></span>
        </div>

        <div class="contentDataBox2">
            <div class="rightMore" @click="gosecondPageFn2">
                <span class="morebox">
                    更多
                    <i class="el-icon-caret-right"></i>
                </span>
            </div>
            <div class="leftImgRightTextBox" v-if="newsData.length!==0">
                <div v-for="(item,index) in newsData" :key="index" class="itemBox" @click="goNewsDetailFn(item)">
                    <img :src="srcUrl+item.titleImgUrl" class="imgbox" />
                    <div class="contentbox">
                        <div class="title overflowone">{{item.pressTopic}}</div>
                        <div class="time">{{item.pressTime | timer}}</div>
                        <div class="synopsis overflowthree">{{item.synopsis}}</div>

                    </div>
                </div>
            </div>
            <div class="emptyBox" v-else>
                <img src="@/assets/imgs/home/emptyimg.png" />
            </div>

        </div>
        <Footer/>
    </div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import { httpService, srcUrl } from "@/service/httpService";
export default {
    components: {
        NavMenu,
        Footer
    },
    data() {
        return {
            srcUrl: srcUrl,
            newsData: [],
            confereeData: [],
        }
    },
    mounted() {
        this.getNews()
        this.getconfereeListFn()
    },
    methods: {
        async getNews() {
            let params = {
                pageSize: 4,
                pageCurrent: 1,
                pressSuperClass: 5,
            };
            let data = await httpService.getNewsList(params);
            if (data.code == 200) {
                this.newsData = data.result.list
            }
        },
        // 会议列表
		async getconfereeListFn() {
			let params = {
				pageSize: 6,
				pageCurrent: 1,
                audit:1,
                status:1,
			};
			let data = await httpService.getconfereeList(params);
			if (data.code == 200) {
				this.confereeData = data.result.list
			}
		},
        goNewsDetailFn(val) {
            this.$router.push({
                path: "/news-detail",
                query: {
                    id: val.pressId,
                },
            });
        },
        jumpdetailFn() {
            this.$router.push({
                path: "/meet-detail",
            });
        },
        gosecondPageFn1() {
            this.$router.push({
                path: "/meet-secondpage/meetactive",

            });
        },
        gosecondPageFn2() {
            this.$router.push({
                path: "/meet-secondpage/brand-active",

            });
        },
        goconfereeDetailFn(val){
			this.$router.push({
				path: "/meet-detail",
				query: {
					id: val.conferenceId,
				},
			});
		},
    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.MeetingActivitiesWarp {
	width: 100%;
	margin: 0 auto;
	.contentDataBox1 {
		width: 1340px;
		margin: 0 auto;
		.meetbox {
			width: 100%;
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			.dataInfoItem {
				width: 428px;
				// height: 280px;
				box-shadow: 0px 3px 12px rgba(30, 80, 174, 0.14);
				margin: 0 25px 29px 0;
				padding: 24px 34px 10px 29px;
				box-sizing: border-box;
				&:nth-child(3n) {
					margin-right: 0;
				}
				// background: url("../../../assets/imgs/solution/page1/img6.png") no-repeat
				//         #fff;
				//       background-position: 100% 100%;
				.meetName {
					font-size: 18px;
					font-weight: bold;
					line-height: 35px;
					color: #448df7;
				}
				.line {
					width: 42px;
					height: 2px;
					background: #448df7;
				}
				.textbox {
					margin-top: 10px;
                    height: 180px;
					font-size: 16px;
					line-height: 30px;
					color: #666666;
				}
				.meetdetailBtn {
					text-align: center;
                    cursor: pointer;
					background: #448df7;
					width: 118px;
					box-sizing: border-box;
					margin: 0 auto;
					margin: 16px auto;
					line-height: 36px;
					color: #ffffff;
				}
			}
		}
	}
	.contentDataBox2 {
		width: 1340px;
		min-height: 600px;
		margin: 0 auto;
		.leftImgRightTextBox {
			.itemBox {
				margin: 0 0 40px 0;
				width: 100%;
				.imgbox {
					width: 301px;
					height: 152px;
				}
				.contentbox {
					width: 77%;
					.time {
						margin-top: 0;
					}
				}
			}
		}
	}
}
</style>


